import {EnableAutoPayDialogContent} from "@bounce/shared/consumer/pages/account-dashboard";
import NiceModal, {NiceModalHocProps, useModal} from "@ebay/nice-modal-react";
import React, {useCallback, useEffect} from "react";
import {Pages} from "~/bi-events/enum";
import {useAmplitude} from "~/contexts";

interface EnableAutoPayDialogProps extends NiceModalHocProps {
  onEnableAutoPay?: () => void;
}

const EnableAutoPayDialog = NiceModal.create(({onEnableAutoPay}: EnableAutoPayDialogProps) => {
  const {pageViewEvent, pageClickEvent} = useAmplitude();
  const modal = useModal();

  const activateAutoPayHandler = useCallback(async (): Promise<void> => {
    pageClickEvent({page: Pages.SWITCH_TO_AUTOPAY, cta: "enable_autopay"});
    onEnableAutoPay?.();

    modal.resolve(true);
    modal.hide();
  }, [onEnableAutoPay]);

  useEffect(() => {
    pageViewEvent({page: Pages.SWITCH_TO_AUTOPAY});
  }, []);

  return <EnableAutoPayDialogContent activateAutoPayHandler={activateAutoPayHandler} />;
});

export default EnableAutoPayDialog;
